<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Document Record</h3>
        <div class="text-xs-right">
          <refresh-button :click-function="refreshData"></refresh-button>
          <!--                    <export-excel-button :export-data="exportData"-->
          <!--                                         v-if="$oauth.checkIfHasPermission(['read document-record'])"/>-->
        </div>
      </v-flex>
      <v-flex xs12>

        <v-card>
          <v-layout class="py-1 mx-2" row wrap>
            <v-flex class="pb-0" xs3>
              <v-text-field
                  :elevation="0"
                  class="hidden-sm-and-down "
                  flat
                  hide-details
                  placeholder="Search by name here..."
                  prepend-inner-icon="search"
                  solo
                  v-model="filters.query"
                  @keypress.enter="fetchFiltersData"
              />
            </v-flex>
            <v-flex xs3 class="pb-0">
              <v-text-field
                  flat
                  hide-details
                  placeholder="Document Number"
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="filters.document_number"
                  @keypress.enter="fetchFiltersData"
              />
            </v-flex>

            <!--                        <v-flex xs2 class="d-flex align-center">-->
            <!--                            <custom-date-range-picker @change="fetchFiltersData"-->
            <!--                                                      v-model="filters.date_range"/>-->
            <!--                        </v-flex>-->
            <v-flex xs3>
              <v-autocomplete
                  :items="document_types"
                  chips
                  clearable
                  deletable-chips
                  flat
                  hide-details
                  item-text="name"
                  item-value="id"
                  label="Document Type"
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="filters.document_type"
                  @change="fetchFiltersData"
              />
            </v-flex>

            <v-flex xs3>
              <v-autocomplete
                  :items="countries"
                  chips
                  clearable
                  deletable-chips
                  flat
                  hide-details
                  item-text="country_name"
                  item-value="id"
                  label="Country"
                  multiple
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="filters.country"
                  @change="fetchFiltersData"
              />
            </v-flex>


          </v-layout>

          <v-divider/>
          <v-card-text class="pa-0">
            <v-data-table
                :headers="headers"
                :items="data"
                :loading="loading"
                :options.sync="pagination"
                :footer-props="footerProps"
                class="elevation-0"
                v-if="$oauth.checkIfHasPermission(['read arrived-report'])"
                hide-default-footer
            >

              <template v-slot:item.document_holding_country="{ item }">
                <td>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                                            <span
                                                v-on="on">{{item.document_holding_country}}</span>
                  </template>
                  <span>{{item.document_holding_country_code}}</span>
                </v-tooltip>
                </td>
              </template>
              <template v-slot:item.document="{ item }">
                <file-display :src="item.document"></file-display>
              </template>

              <template v-slot:item.action="{ item }">
                <v-tooltip top v-if="$oauth.checkIfHasPermission('read traveller-history') && item.traveller">
                  <template v-slot:activator="{ on }">
                    <v-btn
                        class="mr-2"
                        v-if="!currentUser.roles.some(role => role.display_name === 'Special Bureau')"
                        color="primary"
                        dark
                        dense
                        fab
                        v-on="on"
                        :href="'/system/travellers-history/view/'+item.traveller"
                        :to="'/system/travellers-history/view/'+item.traveller"
                        x-small>
                      <v-icon small>mdi-account</v-icon>
                    </v-btn>
                  </template>
                  <span>View Traveller</span>
                </v-tooltip>
                <v-tooltip
                    bottom
                    v-if="currentUser.roles.some(role => role.display_name === 'Special Bureau')"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                        dark
                        fab
                        x-small
                        color="blue darken-3 mx-2"
                        @click="downloadAsPdf(item.traveller)"
                        v-on="on"
                    >
                      <v-icon dark>mdi mdi-file-pdf</v-icon>
                    </v-btn>
                  </template>
                  <span>Download As PDF</span>
                </v-tooltip>
                <v-tooltip top v-if="$oauth.checkIfHasPermission('read traveller-history') && item.has_space">
                  <template v-slot:activator="{ on }">
                    <v-btn
                        class="mr-2"
                        color="red"
                        dark
                        dense
                        fab
                        v-on="on"
                        @click="removeSpace(item)"
                        x-small>
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Remove Space</span>
                </v-tooltip>
              </template>
            </v-data-table>
            <issued-visa-footer @nextClick="handleNextClick" @prevClick="handlePrevClick"
                                :disable-next="disableNext"
                                :disable-prev="disablePrev"
                                :perPage="pagination.itemsPerPage"
                                @rowChanged="fetchDataWithRow"
                                @getCount="getCount"
                                :total="total"
                                :items-loading="totalItemsLoading"
                                :showing-of="showingOf"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex';
import CustomDateRangePicker from "../../components/CustomDateRangePicker";
import {commonStoreMixin} from "../../mixins/commonStoreMixin";
import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
import ExportExcelButton from "../../components/ExportExcelButton";
import OfficerSelectFilter from "../../components/filters/OfficerSelectFilter";
import FileDisplay from "../../components/FileDisplay";

import Http from "axios";
import {VERSIONED_API_URL} from "../../config/config";
import RefreshButton from "@/components/RefreshButton";
import AuthService from '../../oauth/service';

export default {
  name: "DocumentRecord",
  data() {
    return {
      headers: [
        {
          text: "S.N.",
          value: "s_no",
          sortable: false
        },
        {
          text: "Full Name",
          value: "full_name",
          sortable: false
        },
        {
          text: "Document Number",
          value: "document_number",
          sortable: false
        },
        {
          text: "Document",
          value: "document",
          sortable: false
        },
        {
          text: "Type",
          value: "type",
          sortable: false
        },
        {
          text: "Document Holding Country",
          value: "document_holding_country",
          sortable: false
        },
        {
          text: "Time",
          value: "created_at",
          sortable: true
        },
        {
          text: "Expiry Date",
          value: "validity",
          sortable: false
        },
      ],
      pagination: {
          itemsPerPage: 25,
          sortBy: ["documents.created_at"],
          sortDesc: ["true"]
      },
    };
  },
  components: {
    RefreshButton,
    FileDisplay, OfficerSelectFilter, CustomDateRangePicker, IssuedVisaFooter, ExportExcelButton},
  mixins: [commonStoreMixin],
  computed: {
    ...mapGetters({
      loading: "DocumentRecord/reportLoading",
      document_types: "DocumentType/all",
      countries: "CountryList/all",
      currentUser: "AuthUser/user",
    }),
  },
  methods: {
    async removeSpace(item) {
      await this.$dialog.confirm({
        text: "Are you sure about removing space from selected document Number " + item.document_number,
        title: "Warning",
        actions: {
          false: "No",
          true: {
            color: "red",
            text: "Yes",
            handle: () => {
              Http.post(`${VERSIONED_API_URL}/documents/${item.doc_id}/remove-space`)
                  .then(() => {
                    this.$store.commit("Notification/showSuccess", "Successfully space removed");
                    this.fetchData();
                  })
                  .catch(() => {
                    this.$store.commit("Notification/showError", "Something went wrong");
                  })
            }
          }
        }
      });
    },
    downloadAsPdf(item) {
      Http.get(`${VERSIONED_API_URL}/${item}/generate-report`)
          .then((res) => {
            window.open(res.data.link, "_blank");
          })
          .catch(() => {
            this.$store.commit("Notification/showError", "Something went wrong");
          })
    },
    refreshData(){
      this.fetchData();
    },
  },
  created() {
    if (this.$oauth.checkIfHasPermission(['read traveller-history']))
      this.headers.push(
          {
            text: "Action",
            value: "action",
            sortable: false
          })
  },
  mounted() {
    let params = this.$route.params;
    if (params.fromAD) {
      this.filters.type = params.type;
    }
    this.stateName = 'DocumentRecord';
    this.commonState = this.$store.state.DocumentRecord;

    if (this.$store.state.DocumentType.all.length === 0) {
      this.$store.dispatch("DocumentType/fetchAll");
    }
    this.$store.dispatch("CountryList/fetchAllCountries");

    if (this.$route.query && this.$route.query.document_number){
      this.filters.document_number = this.$route.query.document_number
    }
  }
}
</script>
